import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/notify`, { email });
      setDone(true);
      toast.success("You are on the list. We will be in touch soon.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="coming-soon" data-testid="coming-soon-section" className="relative overflow-hidden px-6 py-32 md:py-48">
      <div className="absolute inset-0">
        <img src="/images/vibe-1.png" alt="" className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-ink to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-ink to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-2xl text-center">
        <Reveal>
          <p data-testid="coming-soon-eyebrow" className="mb-8 font-mono text-[11px] uppercase tracking-[0.5em] text-gold">
            Coming Soon
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 data-testid="coming-soon-heading" className="font-serif text-4xl font-light leading-tight text-neutral-100 sm:text-5xl lg:text-6xl">
            The first collection is <em className="text-gold-light">being composed</em>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p data-testid="coming-soon-text" className="mx-auto mt-8 max-w-md text-base font-light leading-relaxed text-neutral-400">
            Our debut fragrances are still taking shape. Leave your email to be the first to know when TABI
            Essence of Strength is unveiled.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          {done ? (
            <div data-testid="notify-success" className="mx-auto mt-12 flex max-w-md items-center justify-center gap-3 border border-gold/30 bg-gold/5 px-6 py-5">
              <Check className="h-4 w-4 text-gold-light" strokeWidth={1.5} />
              <p className="text-sm font-light tracking-wide text-gold-light">
                Thank you — you will be the first to know.
              </p>
            </div>
          ) : (
            <form data-testid="notify-form" onSubmit={submit} className="mx-auto mt-12 flex max-w-md items-end gap-4">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="notify-email-input"
                className="w-full border-b border-white/25 bg-transparent py-3 text-base font-light text-neutral-100 placeholder:text-neutral-600 focus:border-gold focus:outline-none"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="notify-submit-button"
                className="group flex shrink-0 items-center gap-2 border border-gold/40 px-6 py-3 text-[11px] uppercase tracking-[0.25em] text-gold-light transition-all duration-500 hover:border-gold hover:bg-gold/10 disabled:opacity-50"
              >
                {loading ? "Sending" : "Notify Me"}
                <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
